import { gql } from '@apollo/client'

const UPDATE_ORDER_EMAIL = gql`
  mutation UpdateOrderEmail($storeOrderId: String, $email: String) {
    updateOrderEmail(storeOrderId: $storeOrderId, email: $email) {
      id
    }
  }
`

export default UPDATE_ORDER_EMAIL
